<template>
  <div v-farewell="onLeave">
    <div id="farewell" class="farewell-modal" v-if="showExitIntent">
      <div class="container farewell-modal__container">
        <div class="row">
          <div class="col-xs-12 col-md-8 col-md-offset-2">
            <h1 class="farewell-modal__title">
              <strong>Wait!</strong>
              Before you dash off...
            </h1>
            <button class="farewell-modal__close" v-on:click="showExitIntent = false">&times;</button>
            <div class="newsletter-sign-up newsletter-sign-up--no-border">
              <div class="row">
                  <div class="col-xs-6 col-xs-offset-3 col-sm-3 col-sm-offset-0 col-md-4 col-lg-4">
                    <div class="farewell-modal__icon">
                      <img src="/img/orbital/icons/join-us.svg" alt="Join over 7000 tradespeople icon" class="img-responsive">
                    </div>
                  </div>
                  <div class="col-xs-10 col-xs-offset-1 col-sm-9 col-sm-offset-0 col-md-8 col-lg-8 text-left">
                    <p class="newsletter-sign-up__intro newsletter-sign-up__intro--white newsletter-sign-up__intro--xl">Be the first to receive our latest promotional discounts &amp; savings!</p>

                    <div id="mc_embed_signup">
                        <form action="https://orbitalfasteners.us2.list-manage.com/subscribe/post?u=b2d5055e85a3b1b17b86181b2&amp;id=4790bbcf26" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
                            <div id="mc_embed_signup_scroll">
                                <div class="input-group">
                                    <input type="email" value="" name="EMAIL" id="mce-EMAIL" class="form-control farewell-modal__input--force-height" placeholder="Simply enter your email" required>
                                    <span class="input-group-btn">
                                        <button class="btn btn-green newsletter-sign-up__btn" name="subscribe" id="mc-embedded-subscribe" type="submit">Get Discounts</button>
                                    </span>
                                </div>
                                <div id="mce-responses" class="clear">
                                    <div class="response" id="mce-error-response" style="display:none"></div>
                                    <div class="response" id="mce-success-response" style="display:none"></div>
                                </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_b2d5055e85a3b1b17b86181b2_4790bbcf26" tabindex="-1" value=""></div>
                            </div>
                        </form>
                    </div>

                    <p class="newsletter-sign-up__disclaimer newsletter-sign-up__disclaimer--mt-15 newsletter-sign-up__disclaimer--white newsletter-sign-up__disclaimer--lg newsletter-sign-up__disclaimer--opacity-8">By providing your details, you consent to receiving this information by email and other electronic means (including social media).</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app',
    el: '#farewell',
    data() {
      return {
        showExitIntent: false
      }
    },
    methods: {
      onLeave () {
        this.showExitIntent = true;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/FarewellModal.vue